import "./index.js";

(() => {
  if (Sparkle.Pagebuilder.active) {
    return;
  }
  if (jQuery("[data-sparkle-container]").hasClass("no-cta-teaser")) {
    return;
  }

  const components = jQuery("[data-cta]").not("#sparkle-provider-widget-container [data-cta]");
  if (!components.length) {
    return;
  }

  const spComponentsCTAs = components.has("[mobile-cta-target]");
  const mobileCtaDisabled = components.filter("[mobile-cta-disabled]").add(components.has("[mobile-cta-disabled]"));

  const modalCTAs = components.not(".cta_style_teaser").not(spComponentsCTAs).not(mobileCtaDisabled).slice(0, 2);
  const inlineCTAs = components.filter(".cta_style_teaser").slice(0, 2);

  if (modalCTAs.length != null) {
    Sparkle.MobileCTA.renderModalTeaser(modalCTAs, "[data-sparkle-container]");
  }
  if (inlineCTAs.length != null) {
    return Sparkle.MobileCTA.renderInlineTeaser(inlineCTAs, ".credentials");
  }
})();
